import CalendarInCircleIcon from './CalendarInCircleIcon'

export default CalendarInCircleIcon
